jQuery(document).on('gform_post_render', function() {
    var typingTimer;
    var doneTypingInterval = 1000;
    var $input = jQuery('.page-create-account__email-address input');
    var delayTimer;

    $input.on('keyup', function () {
      // clearTimeout(typingTimer);
      // typingTimer = setTimeout(doneTyping, doneTypingInterval);
      //delay keyup event until user stops typing
      
      clearTimeout(delayTimer); // Clear any previously set timeouts

      delayTimer = setTimeout(function() {
          let email = $input.val();
          let i = email.indexOf('@');
          if (i != -1) {
              email = email.substring(email.indexOf('@') + 1);
              jQuery('.requester_email_domain input').val(email);
              jQuery('.requester_email_domain input').trigger('change');
          }
      }, doneTypingInterval); 
    });

    $input.on('keydown', function () {
      clearTimeout(typingTimer);
    });

    function doneTyping () {
      let email = $input.val();
      let i = email.indexOf('@');
      if ( i != -1 ) {
        email = email.substring(email.indexOf('@') + 1);
        getFacilities( email );
      }
    }

    function getFacilities( allowedDomain ) {
      var fieldElement = jQuery('.page-create-account__facilities');
      var inputElement = jQuery('.page-create-account__facilities .gfield_checkbox');
      jQuery(inputElement).empty();
      jQuery.ajax({
        url :eqd_vars.ajax_url,
        type : 'POST',
        data : {
          action : 'npp_get_facilities',
          allowed_domain : allowedDomain
        },
        success : function( response ) {
          if ( response !== 'error' ) {
            jQuery(".admin-hidden-markup").empty();
            jQuery(fieldElement).removeClass('gfield_visibility_hidden');
            jQuery(inputElement).html(response);
          } else {
            jQuery(inputElement).empty();
          }
        }
      });
    }
  }
);
jQuery(document).on('gform_confirmation_loaded', function(event, formId){
  if ( formId == 1 ) {
    if ( jQuery('.entry-content .wpas-alert.wpas-alert-info').length ) {
      jQuery('.entry-content .wpas-alert.wpas-alert-info').hide();
    }
  }
} );